import {  Injectable } from '@angular/core';
import { ToastErrorDetailComponent } from '../components/toast-error-detail/toast-error-detail.component';
import { HotToastService } from '@ngxpert/hot-toast';

@Injectable({
  providedIn: 'root',
})
export class ErrorToastService {

  constructor(private toast: HotToastService) {}

  showErrorWithDetails(message: string, details: string) {


  this.toast.show(ToastErrorDetailComponent, {
      id: 'toast-error-detail',
      data: { message: message, details: details },
      duration: 96000,
      dismissible: true,
      position: 'top-right',
      className: 'app-error',
      style:{
        padding: '0px',
        backroundColor: 'red'
      }
    });
  }
}
